import React from 'react'
import App from '../components/App'

const IndexPage = () => {
	return <App />
}

export default IndexPage
